import axios from "axios";
import { Notice } from "view-design";
import qs from "qs";
import cookies from "@/utils/cookies";
// Set baseURL when debugging production url in dev mode
axios.defaults.baseURL = process.env.VUE_APP_BASEURL;
axios.defaults.withCredentials = true;

axios.interceptors.request.use(
  config => {
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);
// http response 响应拦截器
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response) {
      if (error.response.data && error.response.data.msg) {
        Notice.error({ title: error.response.data.msg });
      }
      // 返回接口返回的错误信息
      return Promise.reject(error.response.data);
    }
  }
);

/**
 * Method to make ajax request
 *
 * @param {object} options - axios config (https://github.com/axios/axios#request-config)
 */
export async function request (options, isFetch) {
  try {
    cookies.setItem("TOKEN", localStorage.getItem("TOKEN"));
    options.headers = options.headers || {};
    options.headers["content-type"] = "application/x-www-form-urlencoded";
    for (const key in options.data) {
      const element = options.data[key];
      if (!element) {
        delete options.data[key];
      }
    }
    if (options.file) {
      options.headers = {
        ...options.headers,
        "Content-Type": "application/octet-stream",
        Accept: "application/octet-stream"
      };
    }
    options.data = qs.stringify(options.data);

    const response = await axios(options);
    const { data } = handleResponse(response);
    return { response, data };
  } catch (error) {
    const response = {
      data: error
    };
    return { response, data: response.data };
  }
}

/**
 * Custom response data handler logic
 *
 * @param {object} response - response data returned by request
 * @return {object} data or error according to status code
 */
function handleResponse (response) {
  const { data } = response;
  const code = data.code || data.status
  // Please modify the status key according to your business logic
  // normally the key is `status` or `code`
  if (response.config.file) {
    if (response.status === 200) {
      const url = window.URL.createObjectURL(data);
      const link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", "export.xls");
      document.body.appendChild(link);
      link.click();
      return { code: 200, msg: "success" };
    } else {
      Notice.error({ title: data.msg });
      return { data };
    }
  } else if (code === 200) {
    return { data };
  } else if (code === 302) {
    window.location.href = data.data;
  } else if (code === 3 || code === 7) {
    Notice.error({ title: data.msg });
    setTimeout(function () {
      // window.location.href = data.data;
    }, 2000);
  } else {
    Notice.error({ title: data.msg });
    return { data };
  }
}
